import {
    getStep,
    listSteps
} from './queries';
import {
    createStep,
    deleteStep,
    updateStep,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CreateStep,
    DeleteStep,
    GetStep,
    ListSteps,
    Step,
    UpdateStep
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListSteps>>({
                                                                       query: listSteps,
                                                                       variables: {
                                                                           filter: filter
                                                                       },
                                                                   });
    // Backend index `record-type-position-index` returns items in position
    // ascending order, but we sort defensively so callers can rely on order.
    const items = response.data?.listSteps.items ?? [];
    return [...items].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetStep>>({
                                                                     query: getStep,
                                                                     variables: {id: id},
                                                                 });
    return response.data?.getStep;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateStep>>({
                                                                        query: createStep,
                                                                        variables: {input: payload},
                                                                    });
    return response.data?.createStep;
};

export const update = async (_id: string, record: Step) => {

    delete record.created;
    delete record.updated;
    delete record.createdByUsername;
    // `phase` is a resolver-populated nested object and is not accepted as
    // input on UpdateStepInput — strip it before sending the mutation.
    delete (record as { phase?: unknown }).phase;
    delete (record as { createdBy?: unknown }).createdBy;

    const response = await client.graphql<GraphQLQuery<UpdateStep>>({
                                                                        query: (updateStep),
                                                                        variables: {input: record},
                                                                    });
    return response.data?.updateStep;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteStep>>({
                                                                        query: (deleteStep),
                                                                        variables: {input: {id: id}},
                                                                    });
    return response.data?.deleteStep;
};
